export default {
    name: 'Nama',
    tel: 'telefon',
    save: 'jimat',
    confirm: 'mengesahkan',
    cancel: 'Batal',
    delete: 'padam',
    complete: 'Selesai',
    loading: 'Memuatkan...',
    telEmpty: 'Sila isi telefon',
    nameEmpty: 'Sila isi nama anda',
    nameInvalid: 'Sila masukkan nama yang sah',
    confirmDelete: 'Adakah anda pasti ingin memadam',
    telInvalid: 'Sila masukkan nombor telefon yang betul',
    vanCalendar: {
        end: 'Selesai',
        start: 'Mulakan',
        title: 'tajuk',
        confirm: 'mengesahkan',
        startEnd: 'Mulakan Selesai',
        weekdays: ['Hari', 'satu', 'dua', 'tiga', 'empat', 'lima', 'enam'],
    },
    vanCascader: {
        select: 'sila pilih',
    },
    vanContactCard: {
        addText: 'Tambah kenalan',
    },
    vanContactList: {
        addText: 'Kenalan baharu',
    },
    vanPagination: {
        prev: 'Halaman sebelumnya',
        next: 'Muka surat seterusnya',
    },
    vanPullRefresh: {
        pulling: 'Tarik ke bawah untuk menyegarkan...',
        loosing: 'Lepaskan muat semula...',
    },
    vanSubmitBar: {
        label: 'semua：',
    },
    vanCoupon: {
        unlimited: 'Tiada sekatan penggunaan',
    },
    vanCouponCell: {
        title: 'kupon',
        tips: 'Tidak tersedia',
    },
    vanCouponList: {
        empty: 'Tiada kupon',
        exchange: 'pertukaran',
        close: 'Tiada kupon',
        enable: 'boleh guna',
        disabled: 'Tidak tersedia',
        placeholder: 'Sila masukkan kod kupon',
    },
    vanAddressEdit: {
        area: 'kawasan',
        postal: 'Poskod',
        areaEmpty: 'Pilih wilayah',
        addressEmpty: 'Sila isikan alamat terperinci',
        postalEmpty: 'Format kod pos salah',
        defaultAddress: 'Tetapkan sebagai alamat penghantaran lalai',
        telPlaceholder: 'Nombor telefon bimbit penerima',
        namePlaceholder: 'Nama penerima',
        areaPlaceholder: 'Pilih wilayah/bandar/daerah',
    },
    vanAddressEditDetail: {
        label: 'alamat',
        placeholder: 'Nombor rumah jalan, nombor bilik lantai dan maklumat lain',
    },
    vanAddressList: {
        add: 'Tambah alamat',
    },
};
